import { Heading, Radio, Text, vars } from '@etg/wings';
import { css } from '@eti/styles';
import { price as priceUtils } from '@eti/utils';
import { Tier } from '@eti/schema-types';
import { getPriceDivided as getPricePerTraveler } from '../../../common/utils/price';
import { stylesVariables } from '../../utils/utils';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  colors: {
    divider: BorderColor
  }
} = vars;
const {
  recommendedBackground,
  originalPriceColor
} = stylesVariables;
const inputSpacing = css`
  margin-bottom: 4px;
  margin-top: 12px;
`;
const originalPriceStyle = css`
  color: ${originalPriceColor};
  min-height: 22px;
  text-decoration: line-through;
`;
const optionStyles = isRecommended => css`
  align-items: center;
  ${isRecommended ? `background-color: ${recommendedBackground}` : ''};
  border-left: 1px solid ${BorderColor};
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 8px;
  padding-bottom: 16px;
  text-align: center;

  html[dir='rtl'] & {
    border-left: unset;
    border-right: 1px solid ${BorderColor};
  }
`;
const labelStyles = css`
  font-size: 0.75rem;
`;
const SelectionOption = _ref => {
  let {
    name,
    numberOfTravelers,
    option,
    priceText,
    shouldShowPricePerPerson
  } = _ref;
  const {
    formatPrice
  } = priceUtils;
  const {
    id,
    originalPrice,
    priceRaw,
    title,
    type
  } = option;
  const formattedOriginalPrice = shouldShowPricePerPerson ? formatPrice(getPricePerTraveler(originalPrice, numberOfTravelers)) : formatPrice(originalPrice);
  const formattedDiscountPrice = shouldShowPricePerPerson ? formatPrice(getPricePerTraveler(priceRaw, numberOfTravelers)) : formatPrice(priceRaw);
  return /*#__PURE__*/_jsxs(Radio.Label, {
    className: optionStyles(type === Tier.Recommended),
    "data-testid": `productBundleItem-${id}`,
    htmlFor: `choice.${name}.${id}`,
    children: [originalPrice > 0 && /*#__PURE__*/_jsx(Text, {
      className: originalPriceStyle,
      children: formattedOriginalPrice
    }), /*#__PURE__*/_jsx(Heading, {
      level: 3,
      children: formattedDiscountPrice
    }), /*#__PURE__*/_jsx("p", {
      className: labelStyles,
      children: priceText
    }), /*#__PURE__*/_jsx(Radio, {
      className: inputSpacing,
      id: `choice.${name}.${id}`,
      value: id
    }), /*#__PURE__*/_jsx("p", {
      className: labelStyles,
      children: title
    })]
  });
};
export default SelectionOption;